
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-elchemy",
      function () {
        return require("private-next-pages/contact-elchemy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-elchemy"])
      });
    }
  